import {
    FunctionField,
    ListContextProvider,
    NumberField,
    TextField,
    useList,
    usePermissions,
    useRecordContext,
    useTranslate,
} from "react-admin";
import { Box, Button, CircularProgress } from "@mui/material";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { DatagridWithHistory } from "shared/src/components/DatagridWithHistory";
import { RaDateField } from "shared/src/components/fields/Ra/RaDateField";
import { useInfiniteScroll } from "shared/src/hooks/useInfiniteScroll";

export const ProductTabContentSKU = (props) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const resource = "arrivals";
    const { isLoading, permissions } = usePermissions();

    const {
        data: skus,
        isPending,
        isFetchingNextPage,
        observerRef,
    } = useInfiniteScroll(
        "skus",
        {
            filter: { product: record?.id },
            pagination: { page: 1, perPage: 25 },
            sort: { field: "id", order: "DESC" },
        },
        { enabled: !!record?.id }
    );

    const listContext = useList({ data: skus, resource: "skus" });

    if (isLoading) {
        return <></>;
    }

    if (isPending) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", p: 3 }}>
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box>
            {permissions.vote({
                resource,
                attribute: "create",
            }) && (
                <Box sx={{ my: 2, mx: 1 }}>
                    <Button
                        onClick={() => props.setDeliveryWindow("edit")}
                        size="small"
                        variant="text"
                        startIcon={<LocalShippingIcon />}
                        title={translate("equip.newDelivery")}
                        aria-label={translate("equip.newDelivery")}
                    >
                        {translate("equip.newDelivery")}
                    </Button>
                </Box>
            )}
            <ListContextProvider value={listContext}>
                <DatagridWithHistory
                    bulkActionButtons={false}
                    rowClick={(id) => `/skus/${id}/show`}
                >
                    <TextField label="equip.labelNumber" source="labelNumber" />
                    <RaDateField label="equip.created" source="createdAt" />
                    <TextField label="equip.manufacturer" source="manufacturer.name" />
                    <TextField label="equip.supplier" source="supplier.name" />
                    <NumberField
                        label="equip.purchasePrice"
                        source="arrival.purchasePrice"
                        options={{
                            style: "currency",
                            currency: "EUR",
                        }}
                    />
                    <NumberField
                        label="equip.currentPrice"
                        source="currentPrice"
                        options={{
                            style: "currency",
                            currency: "EUR",
                        }}
                        sortable={false}
                    />
                    <NumberField
                        label="equip.weight"
                        source="weight"
                        options={{
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 2,
                            style: "unit",
                            unit: "kilogram",
                        }}
                    />
                    <FunctionField
                        label="equip.status"
                        render={(record) => {
                            return (
                                translate(`equip.sku_status_${record.status}`) +
                                " / " +
                                translate(`equip.sku_availability_${record.availability}`)
                            );
                        }}
                    />
                    <TextField label="equip.serialNumber" source="serialNumber" />
                </DatagridWithHistory>
            </ListContextProvider>
            <Box ref={observerRef} sx={{ display: "flex", justifyContent: "center", p: 2 }}>
                {isFetchingNextPage && <CircularProgress size={24} />}
            </Box>
        </Box>
    );
};
